import React from 'react';
import './_app.scss';
import {Controller, V3D, CopyRight, Loading} from './components';

function App() {
    return (
        <div id='app' className="app">
            <V3D/>
            <Controller/>
            <CopyRight/>
            <Loading/>
        </div>
    );
}

export default App;
